// ブラシ先端 (丸) のアルファ画像を硬さから生成する。純ロジック。
//
// 半径 r (0..1) に対して、硬さ h のとき r < h は 1、それ以降は滑らかに 0 へ落とす。
// 端は必ず 1px 程度のアンチエイリアスが付く (h = 1 でも段差にしない)。

export function generateRoundTip(size: number, hardness: number): Uint8Array {
  const data = new Uint8Array(size * size)
  const c = (size - 1) / 2
  const R = size / 2
  const h = Math.max(0, Math.min(1, hardness))
  // 硬さ 1 でも 1px は AA する
  const inner = Math.min(h, 1 - 1 / R)
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      const r = Math.hypot(x - c, y - c) / R
      let a: number
      if (r >= 1) a = 0
      else if (r <= inner) a = 1
      else {
        const t = (r - inner) / (1 - inner)
        // 滑らかな落ち方 (smoothstep の逆 S 字)
        a = 1 - t * t * (3 - 2 * t)
      }
      data[y * size + x] = Math.round(a * 255)
    }
  }
  return data
}

/** 鉛筆: しきい値で 2 値化 */
export function thresholdTip(tip: Uint8Array): Uint8Array {
  const out = new Uint8Array(tip.length)
  for (let i = 0; i < tip.length; i++) out[i] = tip[i]! >= 128 ? 255 : 0
  return out
}
